import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1FontXlProps extends ITextBoxProps {}

export const TextBoxMaxLine1FontXl = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontXlBold,
  alignment = TextAligning.Center,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1FontXlProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
